import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setOptimiseResultsOpen } from "../../../reducers/matrixProfile";
import {
  driverInEditSelector,
  optimiseResultsOpenSelector,
  routeInEditSelector,
  routesSelector,
  routesImpactedSelector,
  isDailyPlanSelector,
} from "../../../reducers/matrixProfile/selectors";
import {
  applyDriverEdit,
  closeDriverEdit,
  revertDriverEdit,
} from "../../../reducers/matrixProfile/thunkActions";

import { Modal } from "../Modal";
import { OptimiseResultsModalActions } from "./OptimiseResultsModalActions";
import { OptimiseResultsModalContent } from "./OptimiseResultsModalContent";
import { ConfirmDailyDriverSaveDilog } from "../../ConfirmDailyDriverSaveDilog";

const OptimiseResultsModal = () => {
  const dispatch = useDispatch();
  const isDailyPlan = useSelector(isDailyPlanSelector);
  const optimiseResultsOpen = useSelector(optimiseResultsOpenSelector);
  const routeEdit = useSelector(routeInEditSelector);
  const driverEdit = useSelector(driverInEditSelector);
  const routes = useSelector(routesSelector);
  const routesImpacted = useSelector(routesImpactedSelector);
  const [showConfirmModal, setShowConfirmModal] = useState();

  const currentRouteCode = routeEdit?.routeCode || driverEdit?.routeCode;
  const { currentRoute, otherRoutes } =
    optimiseResultsOpen && !!Object.keys(routesImpacted).length
      ? routes
          .filter(({ routeCode }) => !!routesImpacted[routeCode])
          .reduce(
            (acc, route) => {
              if (route.routeCode === currentRouteCode)
                acc.currentRoute = route;
              else acc.otherRoutes.push(route);
              return acc;
            },
            { otherRoutes: [] }
          )
      : {};

  const clickClose = () => {
    dispatch(setOptimiseResultsOpen(false));
    if (driverEdit) dispatch(revertDriverEdit());
  };

  const clickOk = () => {
    setShowConfirmModal(false);
    dispatch(setOptimiseResultsOpen(false));
    if (driverEdit && isDailyPlan) dispatch(applyDriverEdit());
    else if (driverEdit) dispatch(closeDriverEdit());
  };

  return (
    <>
      <Modal
        open={optimiseResultsOpen}
        onClose={clickClose}
        title={"Optimise Results"}
        content={
          <>
            <OptimiseResultsModalContent
              currentRoute={currentRoute}
              otherRoutes={otherRoutes}
            />
            <ConfirmDailyDriverSaveDilog
              open={!!showConfirmModal && !!driverEdit}
              onDecline={() => setShowConfirmModal(false)}
              onConfirm={clickOk}
            />
          </>
        }
        actions={
          <OptimiseResultsModalActions
            driverEdit={driverEdit}
            onClickClose={clickClose}
            onOkClicked={
              !driverEdit || !isDailyPlan
                ? clickOk
                : () => setShowConfirmModal(true)
            }
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default OptimiseResultsModal;
